export enum appZIndex {
  ROUTER_GUIDE = 40,
  BANNER_FOOTER = 50,
  FEEDBACK_COLLECTOR = 100,
  METEOROLOGY_CONTROL = 110,
  TOOLBAR = 200,
  TOOLBAR_SMALL_SCREEN = 510,
  DRAWER = 400,
  SEARCH_BOX = 450,
  // Acima do Drawer e da caixa de busca: em telas estreitas o painel ocupa a largura toda e o X ficava coberto.
  INFO_PANEL = 460,
  MAP_SEARCH = 800,
  WAYPOINT_INFO = 800,
  TOOLTIP = 800,
  DRAWER_FULLSCREEN = 800,
  CHAT = 810,
  FEEDBACK_COLLECTOR_FEATURE = 820,
  MODAL = 1000,
  BANNER_DESKTOP = 1000,
  BANNER_MOBILE = 1000,
  GLOBAL_TOAST = 1000,
  GLOBAL_LOADER = 1100
}
